/**
 * Mobile menu.
 *
 * Locks body scroll while open, and traps focus in the panel.
 */
(function() {
    'use strict';

    var toggleBtn = document.querySelector('.mobile-menu-toggle');
    var mobileMenu = document.getElementById('mobile-menu');
    var overlay = document.querySelector('.mobile-menu__overlay');

    if (!toggleBtn || !mobileMenu) return;

    function openMenu() {
        mobileMenu.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        toggleBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('mobile-menu-open');

        // Focus the first menu link for accessibility
        var firstLink = mobileMenu.querySelector('.mobile-menu__link');
        if (firstLink) {
            firstLink.focus();
        }
    }

    function closeMenu() {
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        toggleBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mobile-menu-open');

        // Return focus to toggle button
        toggleBtn.focus();
    }

    function toggleMenu() {
        var isOpen = mobileMenu.classList.contains('is-open');
        if (isOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    toggleBtn.addEventListener('click', toggleMenu);

    if (overlay) {
        overlay.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
            closeMenu();
        }
    });

    var mediaQuery = window.matchMedia('(min-width: 768px)');
    mediaQuery.addEventListener('change', function(e) {
        if (e.matches && mobileMenu.classList.contains('is-open')) {
            closeMenu();
        }
    });

    // Trap focus within mobile menu when open
    mobileMenu.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;

        var focusableElements = mobileMenu.querySelectorAll(
            'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        var firstFocusable = focusableElements[0];
        var lastFocusable = focusableElements[focusableElements.length - 1];

        if (e.shiftKey && document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
        } else if (!e.shiftKey && document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
        }
    });
})();
